import { render, staticRenderFns } from "./VisitData.vue?vue&type=template&id=96201c66&scoped=true&"
import script from "./VisitData.vue?vue&type=script&lang=js&"
export * from "./VisitData.vue?vue&type=script&lang=js&"
import style0 from "./VisitData.vue?vue&type=style&index=0&id=96201c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96201c66",
  null
  
)

export default component.exports